import { render, staticRenderFns } from "./createOrg.vue?vue&type=template&id=7f1c957a"
import script from "./createOrg.vue?vue&type=script&lang=js"
export * from "./createOrg.vue?vue&type=script&lang=js"
import style0 from "./createOrg.vue?vue&type=style&index=0&id=7f1c957a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports